export default {
  data() {
    return {
      required: 'required',
      id: null,
      aclDeviceId: null,
      name: null,
      is_attendance_tracking: false,
      is_device_access: false,
      error: null,
      type: 'acl_device',
      btnLoader: false,
      code: null,
    }
  },

  mounted() {
    this.clearData()
  },
  methods: {
    /**
     * clear from detail
     */
    sidebarToggle() {
      this.id = null
      this.aclDeviceId = null
      this.name = null
      this.is_attendance_tracking = false
      this.is_device_access = false
      this.$refs.tagObserver.reset()
    },
    /**
     * check the form validation
     * @returns if success true then call saveTagDtl Method
     */
    validationForm() {
      this.$refs.tagObserver.validate().then(success => {
        if (success) {
          this.saveTagDtl()
        }
      })
    },
    /**
     * Add & Update the tagTableform details & call tag listing in tagtable
     * @emits tagList
     * @returns projectUser detail add & update
     */
    async saveTagDtl() {
      this.btnLoader = true
      const input = {
        id: this.aclDeviceId,
        name: this.name,
        is_attendance_tracking: this.is_attendance_tracking ? 1 : 0,
        is_device_access: this.is_device_access ? 1 : 0,
      }
      let response = null

      if (this.id) {
        response = await this.getHTTPPutResponse(
          `admin/master/acl-device/update/${this.aclDeviceId}`,
          input,
          true,
        )
      } else {
        response = await this.getHTTPPostResponse(
          'admin/master/acl-device/create',
          input,
          true,
        )
      }

      if (response && response.status === 200) {
        this.$root.$emit('bv::toggle::collapse', 'addacldevice')
        this.$emit('aclDeviceList', 1)
        setTimeout(() => {
          this.btnLoader = false
        }, 200)
      }
      this.btnLoader = false
    },

    /**
     * Clear form details
     */
    clearData() {
      this.aclDeviceId = null
      this.name = null
      this.is_attendance_tracking = false
      this.is_device_access = false
      this.$refs.tagObserver.reset()
    },
  },
}